import React from 'react';
import { tFor } from '../../i18n/i18n.js';

// Footer — rendered on every step (including loading and error states)
// so a customer can always find the policy and contact info without
// having to complete a booking first. Two link buttons on the right
// open Dialogs; the policy/contact content is lazy-loaded on click.
//
// "Powered by SanookPass" helps customers identify the platform operator.
// It's a small link, not a loud banner.

export function Footer({ locale, onOpenPolicy, onOpenContact }) {
  const t = tFor(locale);
  const brand = t('footer.brand');
  return (
    <footer className="sp-footer">
      <div className="sp-footer__powered">
        {t('footer.poweredBy')}{' '}
        <a
          href="https://sanookpass.com"
          target="_blank"
          rel="noopener noreferrer"
          className="sp-footer__brand"
        >
          {brand}
        </a>
      </div>
      <nav className="sp-footer__nav" aria-label="Footer">
        <button
          type="button"
          className="sp-footer__link"
          onClick={onOpenPolicy}
        >
          {t('footer.cancellationPolicy')}
        </button>
        <span className="sp-footer__sep" aria-hidden="true">·</span>
        <button
          type="button"
          className="sp-footer__link"
          onClick={onOpenContact}
        >
          {t('footer.contact')}
        </button>
      </nav>
    </footer>
  );
}
